<template>
  <div class="password-login-form">
    <div class="">
      <div class="left-login">
        <div class="rep-icon-login">
          <router-link
            to="/"
            class="ms-0 ps-0 login-highlight back-btn-pwd"
            >Back</router-link
          >
          <img src="../../assets/images/member-login.svg" alt="image-fluid" />
        </div>
        <div class="">
          <!-- <router-link to="/smart-login">
            <button class="qr-login-btn">
              <img
                src="../../assets/images/qr-icon.svg"
                alt="qr icon"
                class="me-2"
              />Login with QR
            </button>
          </router-link> -->
        </div>
      </div>
    </div>
    <h4 class="login-title mb-0">Login to Continue</h4>

    <div class="auth-form pt-3 pb-3">
      <div class="email-change-wrap mb-3">
        <div class="">{{ memberEmail }}</div>
        <div class="login-highlight" @click="goBack">Change</div>
      </div>

      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form @submit.stop.prevent="handleSubmit(handleLogin)">
          <label for="">Password<span class="required-label mt-2"> *</span></label>
          <div class="login-password-container">
            <input-form-text
              :rules="{ required: true }"
              :customMessages="`Please enter your password`"
              labelFor=""
              labelName="Password"
              placeholder="Please enter your password"
              :inputType="passwordType"
              formGroupClass="form-group mb-1"
              @emitChanges="resetErrorMsg"
              :isErrorFlagSet="passwordErrorFlag"
              :vmodel.sync="password"
            />
            <eye-form-button
              id="password"
              hideOnDefault="false"
              :value="password"
              class="login-toggle-eye-icon"
              type="text"
              @toggle="togglePasswordVisibility"
            ></eye-form-button>

            <div class="valid-error" v-if="passwordErrorFlag && lockoutTime <= 0">
              {{ errorMsg }}
            </div>
          </div>
          <button :disabled="loginLoader || lockoutTime > 0" class="submit-btn mt-3 next-btn ml-0" type="submit">
            <b-spinner v-if="loginLoader" small></b-spinner>
            Login
          </button>
        </form>
      </ValidationObserver>
      <lockout-timer
        v-if="lockoutTime > 0"
        :lockout-seconds="lockoutTime"
        @lockout-expired="handleLockoutExpired"
      />
    </div>

    <div class="left-login mb-0">
      <div></div>
      <router-link to="/forgot-password">
        <div class="login-highlight">Forgot Password?</div>
      </router-link>
    </div>
  </div>
</template>

<script>
import Api from "@/resource/MemberApi";
import InputFormText from "../../components/form/InputFormText.vue";
import EyeFormButton from "../../components/form/EyeFormButton.vue";
import LockoutTimer from "./LockoutTimer"; // Adjust path as needed
import helper from "@/resource/Helper";

export default {
  name: "PasswordLoginForm",
  components: {
    InputFormText,
    EyeFormButton,
    "lockout-timer": LockoutTimer
  },
  data() {
    return {
      password: "",
      loginLoader: false,
      otpLoader: false,
      passwordErrorFlag: false,
      errorMsg: "",
      passwordType: "password",
      isPasswordVisible: true,
      lockoutTime: 0 // Tracks lockout duration from backend
    };
  },
  computed: {
    memberEmail() {
      return this.$store.getters.memberEmail;
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
      this.passwordType = this.isPasswordVisible ? "text" : "password";
    },
    handleLogin() {
      this.loginLoader = true;
      Api.post("v4/auth/login-password-validate", {
        email: this.$store.getters.memberEmail,
        device_id: this.$store.getters.deviceId,
        password: this.password,
      })
        .then((response) => {
          if (response.data.status === "success") {
            this.handleOTPSuccess(response.data.message); // use shared success logic
          }
        })
        .catch((error) => {
          this.loginLoader = false;
          if (error.response?.status === 429) { // Check for 429 Too Many Requests
            // Extract lockout time from error message like "Try again after 563 seconds."
            const lockoutMatch = error.response.data.message?.match(/Try again after (\d+) seconds/);
            if (lockoutMatch && lockoutMatch[1]) {
              this.lockoutTime = parseInt(lockoutMatch[1], 10); // Set lockout time (e.g., 563 seconds)
              this.passwordErrorFlag = false; // Clear error flag for lockout
              this.errorMsg = ''; // Clear error message for lockout
            }
          } else {
            this.passwordErrorFlag = true;
            this.errorMsg = error.response?.data?.message || "Login failed";
          }
        });
    },
    handleOTPSuccess(message) {
      this.$router.push("/default-otp");
      helper.infoMessage(this, "success", message || "OTP sent successfully");
      this.otpLoader = false;
      this.loginLoader = false;
    },
    resetErrorMsg() {
      let app = this;
      app.passwordErrorFlag = false;
      app.emailErrorFlag = false;
      app.errorMsg = "";
    },
    generateOTP() {
      this.otpLoader = true;
      Api.post("v4/auth/generate-otp", {
        email: this.$store.getters.memberEmail,
        device_id: this.$store.getters.deviceId,
        type: "email",
      })
        .then((response) => {
          if (response.data.status === "success") {
            this.$router.push("/default-otp");
            helper.infoMessage(
              this,
              response.data.status,
              response.data.message
            );
          }
          this.otpLoader = false;
          this.loginLoader = false;
        })
        .catch((error) => {
          this.otpLoader = false;
          this.loginLoader = false;
        });
    },
    goBack() {
      this.$router.push({ name: "Login" });
    },
    handleLockoutExpired() {
      this.lockoutTime = 0; // Reset lockout time when timer expires
      this.passwordErrorFlag = false; // Clear error flag to hide error message
      this.errorMsg = ''; // Clear error message
    }
  },
};
</script>

<style>
.multi-step-form {
  margin: auto;
}

.multi-step-form .invalid-feedback {
  color: #e73737;
  background-color: #ffe9e9;
  border-radius: 6px;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
}

.multi-step-form .step-indicator {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.multi-step-form .step-indicator span {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.multi-step-form .step-indicator span.active {
  background-color: #007bff;
  color: white;
}

.multi-step-form form {
  display: flex;
  flex-direction: column;
}

.multi-step-form label {
  margin-top: 10px;
}

.login-password-container {
  position: relative !important;
}

.login-toggle-eye-icon {
  position: absolute;
  top: 6px;
  right: 8px;
  cursor: pointer;
}

.login-password-container .is-valid {
  background-image: none !important;
}

.login-password-container .is-invalid {
  background-image: none !important;
}

.multi-step-form .login-signup-btn-wrap p {
  margin: 0;
  margin-top: 0.75rem;
  margin-right: 0.5rem;
}
</style>